import Vue from "vue";
import Router from "vue-router";

var router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes: []
});

// router.beforeEach((to, from, next) => {

//   this.$headerTitle = null;
//   console.log(this.$headerTitle)
//   next();
// })

Vue.use(Router);

export default router;



//////////////////
// WEBPACK FOOTER
// ./router/index.js
// module id = null
// module chunks = 